import { useQuery } from "react-query";

import { useApiClient } from "api/useApiClient";

import type { SharedArgs } from "../schemas";

const getTherapistCommissionsQueryKey = (args: SharedArgs) => ["getTherapistCommissions", args.params] as const;

export const useGetTherapistCommissions = (args: SharedArgs) => {
  const client = useApiClient();

  return useQuery(getTherapistCommissionsQueryKey(args), () => client.getTherapistCommissions(args));
};
